import { PIXEL_STORAGE_KEYS } from '~/utils/constants'
import { customSetCookie } from '~/utils/deviceInfo'
export default {
  async mounted() {
    // Check if pixel id is existing, then initialize the pixel
    const queryPixelId = this.$route.query.px_id
    const queryBannerId = this.$route.query.banner_id
    const queryBannerAdType = this.$route.query.ad_type
    const queryPlayerType = this.$route.query?.player_type
    const fbclid = this.$route.query.fbclid
    const xClickId = this.$route.query?.click_id
    const referer = this.$route.query.referer ? decodeURIComponent(this.$route.query.referer) : ''

    if (queryPlayerType) {
      customSetCookie(`x-player-type`, queryPlayerType, 10)
    }
    if (xClickId) {
      customSetCookie('x-click-id', xClickId, 10)
    }

    if (fbclid && fbclid !== 'undefined') {
      sessionStorage.setItem('fbclid', fbclid)
    }
    if (referer && fbclid !== 'undefined') localStorage.setItem('referer', fbclid)
    if (referer) this.$cookie.set('x-banner-url', referer)

    // Remove pixel expiration time logic
    if (localStorage.getItem(PIXEL_STORAGE_KEYS.pixelExpiredStorage)) {
      try {
        // Check if today is greater than pixel expiration date, then remove all pixel data
        const today = new Date()
        const expiredDate = new Date(localStorage.getItem(PIXEL_STORAGE_KEYS.pixelExpiredStorage))
        if (today > expiredDate) {
          localStorage.removeItem(PIXEL_STORAGE_KEYS.pixelId)
          localStorage.removeItem(PIXEL_STORAGE_KEYS.bannerId)
          localStorage.removeItem(PIXEL_STORAGE_KEYS.bannerAdType)
        }
      } catch (error) {}
    }

    if (queryPixelId && queryBannerId && queryBannerAdType) {
      const pixelExpirationDate = new Date()
      pixelExpirationDate.setDate(new Date().getDate() + 60)

      localStorage.setItem(PIXEL_STORAGE_KEYS.pixelId, queryPixelId)
      localStorage.setItem(PIXEL_STORAGE_KEYS.bannerId, queryBannerId)
      localStorage.setItem(PIXEL_STORAGE_KEYS.bannerAdType, queryBannerAdType)
      localStorage.setItem(
        PIXEL_STORAGE_KEYS.pixelExpiredStorage,
        pixelExpirationDate.toISOString()
      )
    }

    let pixelId =
      queryPixelId ||
      localStorage.getItem(PIXEL_STORAGE_KEYS.pixelId) ||
      this.$store.state.pixel.pixelId
    let bannerId =
      queryBannerId ||
      localStorage.getItem(PIXEL_STORAGE_KEYS.bannerId) ||
      this.$store.state.pixel.bannerId
    let bannerAdType = queryBannerAdType || localStorage.getItem(PIXEL_STORAGE_KEYS.bannerAdType)

    if (pixelId) this.$store.commit('pixel/setPixelId', pixelId)
    if (bannerId) this.$store.commit('pixel/setBannerId', bannerId)

    // Check pixel banner status from API
    const response = await this.$store.dispatch('pixel/getPixelBannerStatus', {
      xDirectBannerId: bannerId,
      xBannerPixelId: pixelId
    })
    if (!response || !response?.status) {
      return
    }

    if (response.pixel_id) pixelId = response.pixel_id
    if (response.banner_id) bannerId = response.banner_id
    if (response.ad_type) bannerAdType = response.ad_type

    this.initializePixel(pixelId, bannerId, bannerAdType)
  },
  methods: {
    initializePixel(pixelId, bannerId, bannerAdType) {
      const openCount = localStorage.getItem('open_count')
      // For PWA only, except store page
      if (this.isPwaStandalone() || this.$route.path === '/banners/pwa') {
        if (pixelId && bannerId && parseFloat(bannerAdType || '') === 2) {
          this.$store.commit('pixel/setIsPwa', true)
          this.$initFbPixel(pixelId)

          // Init first view
          if (!openCount && this.isPwaStandalone()) {
            this.trackPixelEvent(this.PIXEL_EVENTS.firstView)
            localStorage.setItem('open_count', '1')
          }
        }
      }
      // For H5
      else if (pixelId && bannerId && parseFloat(bannerAdType || '') === 3) {
        this.$store.commit('pixel/setIsH5', true)
        this.$initFbPixel(pixelId)
        // Init first view
        if (!openCount) {
          this.trackPixelEvent(this.PIXEL_EVENTS.firstView)
          localStorage.setItem('open_count', '1')
        }
      }
    }
  }
}
